import * as React from 'react';
import RcTooltip from 'rc-tooltip';

export interface Props {
  visible?: boolean;
  overlay: React.ComponentClass<any> | React.FC<any> | React.ReactElement<any>;
  trigger: ('hover' | 'click')[];
  onVisibleChange?: (a: any) => void;
  placement: 'top' | 'right' | 'bottom' | 'topRight' | 'bottomRight';
}

const Tooltip: React.FC<Props> = (props) =>
  __ISSERVER__ ? (
    <>{props.children}</>
  ) : (
    //@ts-ignore @types/rc-tooltip does not have animation in Props
    <RcTooltip {...props} animation="zoom" />
  );

export default Tooltip;
